/* =====================================================================
   SEO — configuration centrale des routes
   ---------------------------------------------------------------------
   ⚠️ Ce fichier ne doit contenir AUCUN import : il est lu à la fois par
   l'application React (src/seo/seoConfig.js) et par le script Node
   scripts/prerender.mjs (génération des pages statiques + sitemap.xml).

   - indexable: true  → page pré-rendue, présente dans sitemap.xml
   - indexable: false → page pré-rendue avec <meta robots="noindex,follow">
                        (pages encore vides). Passez-la à true dès que la
                        page a du contenu réel.
===================================================================== */

export const SITE_URL = "https://elementsgroup.pro";
export const SITE_NAME = "Elements Group";

export const DEFAULT_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/elements-590a4.firebasestorage.app/o/Design%20sans%20titre.png?alt=media&token=50b366eb-de6a-4654-ae75-a39a159044ef";

export const DEFAULT_TITLE =
  "Elements Group | Cuisines sur mesure & aménagement intérieur haut de gamme";

export const DEFAULT_DESCRIPTION =
  "Elements Group conçoit et fabrique des cuisines sur mesure, dressings et aménagements intérieurs haut de gamme en Tunisie, en France et à l'international.";

/* ---------------------------------------------------------------------
   Pages statiques
--------------------------------------------------------------------- */
export const STATIC_ROUTES = [
  {
    path: "/",
    indexable: true,
    title: DEFAULT_TITLE,
    description:
      "Cuisines sur mesure, dressings et aménagements intérieurs haut de gamme : conception, fabrication et pose en Tunisie, en France et à l'international.",
  },
  {
    path: "/contact",
    indexable: true,
    label: "Contact",
    title: "Contact & rendez-vous | Elements Group – Tunisie & France",
    description:
      "Contactez Elements Group pour votre cuisine, dressing ou aménagement sur mesure : rendez-vous, devis et accompagnement en Tunisie, en France et à l'international.",
  },

  /* ---------- Elements Group ---------- */
  {
    path: "/elements/histoire",
    indexable: true,
    label: "Notre histoire",
    title: "Notre histoire & vision du sur-mesure | Elements Group",
    description:
      "L'histoire d'Elements Group : une vision du sur-mesure haut de gamme, des cuisines et intérieurs conçus avec exigence, précision et matériaux premium.",
  },
  {
    path: "/elements/createurs",
    indexable: true,
    label: "Nos créateurs",
    title: "Nos créateurs & notre équipe | Elements Group",
    description:
      "Rencontrez les designers et artisans d'Elements Group qui imaginent et réalisent des cuisines, dressings et intérieurs sur mesure haut de gamme.",
  },
  {
    path: "/elements/partenaires",
    indexable: true,
    label: "Partenaires",
    title: "Partenaires, fournisseurs & marques | Elements Group",
    description:
      "Les partenaires, fournisseurs et marques premium avec lesquels Elements Group réalise ses cuisines et aménagements sur mesure, ainsi que ses collaborations B to B.",
  },
  {
    path: "/elements/atelier",
    indexable: false, // page vide pour l'instant
    label: "L'atelier",
    title: "Nos ateliers, store & bureaux | Elements Group",
    description:
      "Découvrez les ateliers de fabrication, le showroom et les bureaux d'Elements Group.",
  },

  /* ---------- Collections ---------- */
  {
    path: "/collections/cuisines",
    indexable: true,
    label: "Cuisines sur mesure",
    title: "Cuisines sur mesure haut de gamme en Tunisie | Elements Group",
    description:
      "Nos réalisations de cuisines sur mesure haut de gamme à Tunis, Sfax, Sousse, Hergla… Îlots, grès, bois et façades premium : découvrez chaque projet en images.",
  },
  {
    path: "/collections/dressings",
    indexable: true,
    label: "Dressings sur mesure",
    title: "Dressings sur mesure & solutions de rangement | Elements Group",
    description:
      "Dressings sur mesure ouverts ou fermés, en U, en angle ou sous pente : découvrez nos réalisations haut de gamme en Tunisie, pensées pour optimiser chaque espace.",
  },
  {
    path: "/collections/amenagement",
    indexable: false,
    label: "Aménagement intérieur",
    title: "Aménagement intérieur sur mesure | Elements Group",
    description:
      "Solutions d'aménagement intérieur sur mesure pour espaces résidentiels et professionnels haut de gamme.",
  },
  {
    path: "/collections/accessoires",
    indexable: false,
    label: "Accessoires",
    title: "Accessoires & solutions de rangement | Elements Group",
    description:
      "Accessoires, rangements intelligents et équipements pour cuisines et dressings haut de gamme.",
  },
  {
    path: "/collections/textures",
    indexable: false,
    label: "Textures & finitions",
    title: "Textures & finitions | Elements Group",
    description:
      "Matériaux, textures et finitions haut de gamme : bois, grès, laques, verre et quartz.",
  },

  /* ---------- SAV ---------- */
  {
    path: "/sav/garantie",
    indexable: true,
    label: "Garantie",
    title: "Garantie de votre cuisine sur mesure | Elements Group",
    description:
      "Quelles sont les garanties de votre cuisine Elements Group ? Durées, éléments couverts et conditions de garantie de nos cuisines et aménagements sur mesure.",
  },
  {
    path: "/sav/service-apres-vente",
    indexable: true,
    label: "Service après-vente",
    title: "Service après-vente | Elements Group",
    description:
      "Le service après-vente Elements Group reste à votre écoute après l'installation : assistance, réglages, interventions et suivi de votre cuisine sur mesure.",
  },
  {
    path: "/sav/kit-nettoyage",
    indexable: false,
    label: "Kit de nettoyage",
    title: "Kit de nettoyage & entretien | Elements Group",
    description:
      "Produits et conseils d'entretien pour préserver vos façades, plans de travail et finitions.",
  },

  /* ---------- Export ---------- */
  {
    path: "/export/projets-international",
    indexable: true,
    label: "Projets internationaux",
    title: "Cuisines sur mesure en France & à l'international | Elements Group",
    description:
      "Elements Group conçoit, livre et installe des cuisines sur mesure haut de gamme en France (Île-de-France, Nice…) et à l'international. Découvrez nos projets.",
  },
  {
    path: "/export/carte",
    indexable: true,
    label: "Carte des réalisations",
    title: "Carte des réalisations dans le monde | Elements Group",
    description:
      "La carte des réalisations Elements Group : cuisines et aménagements sur mesure en Tunisie, en France et à l'international.",
  },
  {
    path: "/export/temoignages-clients",
    indexable: false,
    label: "Témoignages clients",
    title: "Témoignages clients | Elements Group",
    description:
      "Avis et témoignages de clients ayant confié leur projet sur mesure à Elements Group.",
  },
];

/* ---------------------------------------------------------------------
   Collections de projets (pages dynamiques /:name)
   exportName  = nom de l'export dans Pages/Collections/CollectionsData.js
   imageFolder = dossier dans src/images/
--------------------------------------------------------------------- */
export const PROJECT_COLLECTIONS = [
  {
    exportName: "projectsCuisinesData",
    basePath: "/collections/cuisines",
    imageFolder: "Cuisines",
    parentLabel: "Cuisines sur mesure",
    kind: "Cuisine sur mesure",
  },
  {
    exportName: "projectsDressings",
    basePath: "/collections/dressings",
    imageFolder: "Dressings",
    parentLabel: "Dressings sur mesure",
    kind: "Dressing sur mesure",
  },
  {
    exportName: "projectsCuisinesIntData",
    basePath: "/export/projets-international",
    imageFolder: "ProjetsInter",
    parentLabel: "Projets internationaux",
    kind: "Cuisine haut de gamme",
  },
];

/* Route rendue pour générer build/404.html */
export const NOT_FOUND_PATH = "/404";

/* ---------------------------------------------------------------------
   Helpers partagés (React + Node)
--------------------------------------------------------------------- */
export const normalizePath = (p = "/") => {
  let path = p.split("?")[0].split("#")[0] || "/";
  if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);
  return path;
};

/** "Project 01 — Baie des Anges, Tunisie" → { num: "01", place: "Baie des Anges, Tunisie" } */
export const parseProjectTitle = (title = "") => {
  const m = title.match(/^\s*Proje(?:c)?t\s*(\d+)\s*[—–-]+\s*(.+)$/i);
  if (!m) return { num: "", place: title.trim() };
  const place = m[2]
    .replace(/\s+,/g, ",")
    .replace(/\s{2,}/g, " ")
    .trim();
  const nice = (place.charAt(0).toUpperCase() + place.slice(1)).replace(
    /Île de France/gi,
    "Île-de-France"
  );
  return { num: m[1], place: nice };
};

export const cleanText = (txt = "") =>
  txt
    .replace(/\s+/g, " ")
    .replace(/\s+([.,])/g, "$1")
    .trim();

export const truncate = (txt = "", max = 158) => {
  const t = cleanText(txt);
  if (t.length <= max) return t;
  const cut = t.slice(0, max - 1);
  return cut.slice(0, cut.lastIndexOf(" ")).replace(/[,;:.\s]+$/, "") + "…";
};

export const projectSeo = (collection, key, project) => {
  const { num, place } = parseProjectTitle(project.title);
  const numLabel = num ? ` – Projet ${num}` : "";
  const body = cleanText(project.description);
  return {
    path: `${collection.basePath}/${key}`,
    label: num ? `Projet ${num} – ${place}` : place,
    place,
    title: `${collection.kind} ${place}${numLabel} | ${SITE_NAME}`,
    description: truncate(
      `${collection.kind} – ${place} : ${body.charAt(0).toLowerCase()}${body.slice(1)}`
    ),
  };
};
